import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  backHref?: string;
  backLabel?: string;
}

export function PageHeader({
  title,
  subtitle,
  actions,
  backHref = '/games',
  backLabel = 'Back to games'
}: PageHeaderProps) {
  return (
    <header className="border-b border-neutral-800">
      <div className="max-w-5xl mx-auto px-3 py-3 sm:px-4 sm:py-4">
        {/* Back Link */}
        <Link
          to={backHref}
          className="inline-flex items-center gap-2 text-sm text-neutral-500 hover:text-white transition-colors mb-4"
        >
          <ArrowLeft className="w-4 h-4" />
          {backLabel}
        </Link>

        {/* Title Row */}
        <div className="flex items-center justify-between gap-2 sm:gap-4">
          <div className="min-w-0 flex-1">
            <h1 className="text-base sm:text-lg font-semibold text-white truncate">{title}</h1>
            {subtitle && (
              <div className="text-xs sm:text-sm text-neutral-500">{subtitle}</div>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">{actions}</div>
          )}
        </div>
      </div>
    </header>
  );
}
